import LockOutlined from "@mui/icons-material/LockOutlined";

import { LockLine, OpenLink } from "./styles";
import { SettlementLockProps } from "./types";

export const SettlementLock = ({ settlement }: SettlementLockProps) => {
  const { investmentId, investmentAccountName, kind } = settlement;
  const owner = kind === "CASHBACK" ? "buy" : "trade";
  const openLink =
    investmentId === null ? null : (
      <>
        <span aria-hidden>·</span>
        <OpenLink
          href={`/investments/${investmentId}`}
          aria-label={`Open the ${owner} on ${investmentAccountName}`}
        >
          Open
        </OpenLink>
      </>
    );

  return (
    <LockLine title={`Managed by a ${owner} on ${investmentAccountName}`}>
      <LockOutlined aria-hidden />
      <span>{`Managed by a ${owner}`}</span>
      {openLink}
    </LockLine>
  );
};
